import React, {createContext} from 'react';

const LibraryContext = createContext(null);

export default LibraryContext;